package io.horion.auth.domain.models
enum class Role {
    USER,
    ADMIN
}